import { Stack, Text } from '@mantine/core';
import { Dropzone } from '@mantine/dropzone';
import { IconUpload } from '@tabler/icons-react';

interface ImageDropzoneProps {
  onDrop: (files: File[]) => void;
}

export function ImageDropzone({ onDrop }: ImageDropzoneProps) {
  return (
    <Dropzone
      onDrop={onDrop}
      accept={['image/png', 'image/jpeg', 'image/webp']}
      maxSize={5 * 1024 * 1024}
    >
      <Stack align="center" justify="center" style={{ height: 200 }}>
        <IconUpload size={50} stroke={1.5} />
        <Text ta="center">Kéo thả hình ảnh vào đây hoặc bấm để chọn file</Text>
        <Text ta="center" size="sm" c="dimmed">Chấp nhận PNG, JPEG, WebP / Tối đa 5MB</Text>
      </Stack>
    </Dropzone>
  );
} 